import {
  normalizeActivityCoverDefaultsResponse,
  type ActivityCoverDefaults,
} from "@/lib/activity-cover-defaults";

export type ActivityCoverDefaultsRequest = (
  method: "GET" | "PATCH",
  path: string,
  data?: ActivityCoverDefaults
) => Promise<any>;

const ENDPOINT = "accounts/activity-cover-defaults";

export async function getActivityCoverDefaults(
  request: ActivityCoverDefaultsRequest
): Promise<ActivityCoverDefaults | null> {
  const response = await request("GET", ENDPOINT);
  if (!response?.error) return normalizeActivityCoverDefaultsResponse(response);
  throw response.error;
}

export async function setActivityCoverDefaults(
  request: ActivityCoverDefaultsRequest,
  defaults: ActivityCoverDefaults
): Promise<ActivityCoverDefaults | null> {
  const categoryId = defaults.categoryId?.trim();
  if (defaults.sourceMode !== "characters" && !categoryId) {
    throw new Error("ACTIVITY_COVER_DEFAULTS_CATEGORY_REQUIRED");
  }
  const payload: ActivityCoverDefaults = {
    sourceMode: defaults.sourceMode,
    ...(categoryId ? { categoryId } : {}),
  };
  const response = await request("PATCH", ENDPOINT, payload);
  if (!response?.error) return normalizeActivityCoverDefaultsResponse(response);
  throw response.error;
}
